import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {WebTerminalSearchModel} from "../web-terminal-search.model";
import {WebTerminalEntityModel} from "../web-terminal-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-web-terminal-search-page",
    templateUrl: "./web-terminal-search-page.component.html",
    providers: [provideSearchModel(WebTerminalSearchModel), provideEntityModel(WebTerminalEntityModel)]
})
export class WebTerminalSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
